/* ==========================================================================
   product-bump.js — v4.1 (13/08/2026)
   --------------------------------------------------------------------------
   Orchestrateur unique de l'ajout au panier sur la fiche produit.

   Contexte : le bloc « Choisissez votre pack » posait son propre écouteur sur
   #productMainSubmit et ajoutait le produit principal sans jamais appeler
   preventDefault(). Le formulaire natif ajoutait le même produit en parallèle :
   UN clic = DEUX montres au panier, et un tiroir rendu depuis un état périmé
   (message « Une erreur est survenue lors de l'actualisation de votre panier »).

   Ce script est désormais le seul à écrire dans le panier depuis la fiche.
   Il envoie UNE requête contenant :
     - la montre (+ ses propriétés de ligne, dont la gravure)
     - l'extension de garantie si un pack est sélectionné
     - la ligne « Gravure personnalisée » si l'option est cochée

   v4.1 : la propriété « Pour » reprend le titre du produit (h1) et non le
   titre SEO de la page.

   Dépend de deux points dans sections/main-product.liquid :
     1. le bloc pack sort si window.__twsAddonsInitialised est vrai
     2. le pack porte data-bundle-variant="<id de variante>"
   ========================================================================== */

(function () {
  'use strict';

  if (window.__twsAddonsInitialised) return;
  window.__twsAddonsInitialised = true;

  var ADDON_SELECTOR = '[data-addon]';
  var PACK_SELECTOR = '.cv__ProductBundle-label.active[data-bundle-variant]';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  ready(function () {
    var buttons = Array.prototype.slice.call(document.querySelectorAll('#productMainSubmit'));
    if (!buttons.length) return;

    var blocks = Array.prototype.slice.call(document.querySelectorAll(ADDON_SELECTOR));
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var errorWrapper = document.querySelector('.product-form__error-message-wrapper');
    var errorMessage = document.querySelector('.product-form__error-message');
    var busy = false;

    /* ---------- 1. Comportement de chaque bloc add-on (gravure) ---------- */
    blocks.forEach(function (block) {
      var checkbox = block.querySelector('[data-addon-checkbox]');
      var panel = block.querySelector('[data-gravure-panel]');
      var input = block.querySelector('[data-gravure-input]');
      var counter = block.querySelector('[data-gravure-count]');
      var select = block.querySelector('[data-addon-select]');

      if (checkbox) {
        checkbox.addEventListener('change', function () {
          if (!panel) return;
          panel.hidden = !checkbox.checked;
          if (checkbox.checked && input) {
            hideError(block);
            input.focus();
          }
        });
      }

      if (input && counter) {
        var refresh = function () {
          counter.textContent = String(input.value.length);
          if (input.value.trim()) hideError(block);
        };
        input.addEventListener('input', refresh);
        refresh();
      }

      if (select) {
        select.addEventListener('change', function () {
          var option = select.options[select.selectedIndex];
          if (!option) return;
          var image = block.querySelector('.bump-product-image');
          var price = block.querySelector('.bump-product-price');
          if (image && option.dataset.variantImgsrc) image.src = option.dataset.variantImgsrc;
          if (price && option.dataset.variantPrice) price.innerHTML = option.dataset.variantPrice;
          if (checkbox) checkbox.dataset.productId = select.value;
        });
      }
    });

    /* ---------- 2. Interception de l'ajout au panier ---------- */
    buttons.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        if (busy) return;
        if (button.getAttribute('aria-disabled') === 'true') return;
        submit(button);
      });
    });

    /* ---------- 3. Construction de la requête unique ---------- */
    function submit(button) {
      var mainVariantId = getMainVariantId();
      if (!mainVariantId) {
        showError('Variante introuvable. Merci de recharger la page.');
        return;
      }

      var invalid = null;
      blocks.forEach(function (block) {
        if (invalid) return;
        var checkbox = block.querySelector('[data-addon-checkbox]');
        var input = block.querySelector('[data-gravure-input]');
        if (checkbox && checkbox.checked && input && !input.value.trim()) invalid = block;
      });
      if (invalid) {
        showFieldError(invalid);
        return;
      }

      var titre = getMainProductTitle();
      var properties = collectProperties();
      var extras = [];

      var pack = document.querySelector(PACK_SELECTOR);
      if (pack && pack.getAttribute('data-bundle-variant')) {
        extras.push({
          id: pack.getAttribute('data-bundle-variant'),
          quantity: 1,
          properties: { 'Pour': titre }
        });
      }

      blocks.forEach(function (block) {
        var checkbox = block.querySelector('[data-addon-checkbox]');
        if (!checkbox || !checkbox.checked) return;
        var variantId = checkbox.dataset.productId;
        if (!variantId) return;

        var props = { 'Pour': titre };
        var input = block.querySelector('[data-gravure-input]');
        if (block.getAttribute('data-addon-gravure') && input && input.value.trim()) {
          props['Texte'] = input.value.trim();
        }
        extras.push({ id: variantId, quantity: 1, properties: props });
      });

      var payload = new FormData();

      if (extras.length === 0) {
        payload.append('id', mainVariantId);
        payload.append('quantity', getQuantity());
        Object.keys(properties).forEach(function (key) {
          payload.append('properties[' + key + ']', properties[key]);
        });
      } else {
        payload.append('items[0][id]', mainVariantId);
        payload.append('items[0][quantity]', getQuantity());
        Object.keys(properties).forEach(function (key) {
          payload.append('items[0][properties][' + key + ']', properties[key]);
        });
        extras.forEach(function (item, i) {
          var n = i + 1;
          payload.append('items[' + n + '][id]', item.id);
          payload.append('items[' + n + '][quantity]', item.quantity);
          Object.keys(item.properties).forEach(function (key) {
            payload.append('items[' + n + '][properties][' + key + ']', item.properties[key]);
          });
        });
      }

      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }));
        payload.append('sections_url', window.location.pathname);
        cart.setActiveElement(document.activeElement);
      }

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = payload;

      setLoading(button, true);
      hideError();

      fetch(window.routes.cart_add_url, config)
        .then(function (response) { return response.json(); })
        .then(function (response) {
          if (response.status) {
            showError(response.description || response.message);
            return;
          }
          if (!cart) {
            window.location = window.routes.cart_url;
            return;
          }
          cart.renderContents(response);
        })
        .catch(function (e) {
          console.error('[TWS addons]', e);
          showError('Une erreur est survenue. Merci de réessayer.');
        })
        .finally(function () {
          setLoading(button, false);
          if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        });
    }

    /* ---------- 4. Utilitaires ---------- */
    function getMainVariantId() {
      var hidden = document.getElementById('mainSelectedProduct');
      if (hidden && hidden.value) return hidden.value;
      var formInput = form && form.querySelector('[name="id"]');
      if (formInput && formInput.value) return formInput.value;
      return null;
    }

    /* Le titre du produit, pas celui de la page : le champ « Pour » est lu
       par l'atelier, il doit porter le nom commercial exact. */
    function getMainProductTitle() {
      var heading = document.querySelector('.product__title h1, h1.product__title, .product__title');
      if (heading && heading.textContent.trim()) return heading.textContent.trim();

      var packTitle = document.querySelector('.cv__ProductBundle-label:not([data-bundle-variant]) .cv__product-bundle-title');
      if (packTitle && packTitle.textContent.trim()) return packTitle.textContent.trim();

      var meta = document.querySelector('meta[property="og:title"]');
      if (meta && meta.content) return meta.content;

      return document.title;
    }

    function getQuantity() {
      var field = document.querySelector('input[name="quantity"]');
      var value = field ? parseInt(field.value, 10) : 1;
      return value > 0 ? value : 1;
    }

    function collectProperties() {
      var result = {};
      var fields = document.querySelectorAll('[name^="properties["]');

      Array.prototype.forEach.call(fields, function (field) {
        if (field.disabled) return;

        var block = field.closest(ADDON_SELECTOR);
        if (block) {
          var checkbox = block.querySelector('[data-addon-checkbox]');
          if (!checkbox || !checkbox.checked) return;
        }

        if (field.type === 'checkbox' || field.type === 'radio') {
          if (!field.checked) return;
        }

        var value = (field.value || '').trim();
        if (!value) return;

        var match = field.name.match(/^properties\[(.+)\]$/);
        if (!match) return;

        result[match[1]] = value;
      });

      return result;
    }

    function setLoading(button, state) {
      busy = state;
      var spinner = button.querySelector('.loading-overlay__spinner');
      if (state) {
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
      } else {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      }
    }

    function showFieldError(block) {
      var message = block.querySelector('[data-gravure-error]');
      var input = block.querySelector('[data-gravure-input]');
      if (message) message.hidden = false;
      if (input) {
        input.classList.add('bump-gravure__input--error');
        input.focus();
        input.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function hideError(block) {
      if (block) {
        var message = block.querySelector('[data-gravure-error]');
        var input = block.querySelector('[data-gravure-input]');
        if (message) message.hidden = true;
        if (input) input.classList.remove('bump-gravure__input--error');
        return;
      }
      if (errorWrapper) errorWrapper.setAttribute('hidden', '');
    }

    function showError(text) {
      if (errorWrapper && errorMessage) {
        errorMessage.textContent = text;
        errorWrapper.removeAttribute('hidden');
      } else {
        console.warn('[TWS addons]', text);
      }
    }
  });
})();
